import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18","key":"svg-0"}],["path",{"d":"M18 12a6 6 0 0 1 -6 6","key":"svg-1"}]]

const IconInnerShadowBottomRight = createReactComponent('outline', 'inner-shadow-bottom-right', 'InnerShadowBottomRight', __iconNode);

export default IconInnerShadowBottomRight;